import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AppService } from '@base/app.service';
import { CompanyService } from '@company/company.service';
import { User, Role } from '@models';
import * as fromUtils from '@utils';
import { IUser, User as Session } from '@base/interfaces';

@Injectable()
export class CompanyResolver implements Resolve<any> {
  private userSession: User = null;
  constructor(
    private router: Router,
    private mainService: AppService,
    private companyService: CompanyService,
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    const queryParams = {ordering: ['-updated_at', ], };
    let auxUser: IUser = new Session();

    this.mainService.getCurrentUser().subscribe(
      (user) => {
        this.userSession = Object.assign({}, new User(), user);
        auxUser = Object.assign({}, auxUser, this.userSession);
        const role: Role = Object.assign({}, new Role(), user.role);
        const filterCompanies = (role.code === fromUtils.ROLES.CUSTOMER || role.code === fromUtils.ROLES.ANALYST);
        auxUser = (filterCompanies) ? auxUser : null;
      }
    );

    // lanzar la peticion de carga de empresas
    this.companyService.getCompanies(auxUser, queryParams);
    return of(true);
  }
}
